import { render, staticRenderFns } from "./RdCreate.vue?vue&type=template&id=161d7870&scoped=true&"
import script from "./RdCreate.vue?vue&type=script&lang=js&"
export * from "./RdCreate.vue?vue&type=script&lang=js&"
import style0 from "./RdCreate.vue?vue&type=style&index=0&id=161d7870&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "161d7870",
  null
  
)

export default component.exports